import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { CandidateAvailabilityContainer } = await import('@containers/CandidateAvailability/index');
    return {
        Component: CandidateAvailabilityContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
